import { render, staticRenderFns } from "./afficheRelances.vue?vue&type=template&id=55ca070d&scoped=true"
import script from "./afficheRelances.vue?vue&type=script&lang=js"
export * from "./afficheRelances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca070d",
  null
  
)

export default component.exports